import React, { useState } from 'react';
import ToolLayout from './layout/ToolLayout';
import Card, { CardHeader } from './ui/Card';
import Button from './ui/Button';
import CopyButton from './ui/CopyButton';
import FeedbackMessage from './ui/FeedbackMessage';
import FormField from './ui/FormField';

const JsonFormatter = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [feedback, setFeedback] = useState({ type: 'info', message: '' });
  const [mode, setMode] = useState('format');

  const handleProcess = () => {
    if (!input.trim()) {
      setFeedback({ type: 'error', message: 'Paste some JSON first.' });
      return;
    }

    try {
      const parsed = JSON.parse(input);
      const result =
        mode === 'format' ? JSON.stringify(parsed, null, 2) : JSON.stringify(parsed);
      setOutput(result);
      setFeedback({
        type: 'success',
        message: mode === 'format' ? 'Valid JSON' : 'Minified successfully',
      });
    } catch (e) {
      setOutput('');
      setFeedback({ type: 'error', message: e.message });
    }
  };

  const handleValidateOnly = () => {
    if (!input.trim()) {
      setFeedback({ type: 'error', message: 'Paste some JSON first.' });
      return;
    }

    try {
      JSON.parse(input);
      setFeedback({ type: 'success', message: 'Valid JSON' });
    } catch (e) {
      setFeedback({ type: 'error', message: e.message });
    }
  };

  return (
    <ToolLayout
      title="JSON Formatter / Validator"
      description="Format, validate, and minify JSON in the browser"
      category="Encoding & Data"
      note="Local processing in the browser"
    >
      <div className="tool-grid tool-grid--tool-page">
        <Card>
          <CardHeader title="JSON Input" description="Paste raw JSON to format, minify, or validate." />
          <FormField label="Mode">
            <div className="tool-actions">
              <Button
                variant={mode === 'format' ? 'primary' : 'secondary'}
                onClick={() => setMode('format')}
              >
                Format
              </Button>
              <Button
                variant={mode === 'minify' ? 'primary' : 'secondary'}
                onClick={() => setMode('minify')}
              >
                Minify
              </Button>
            </div>
          </FormField>
          <FormField label="JSON Input">
            <textarea
              className="app-textarea"
              rows="10"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder='{ "key": "value" }'
            />
          </FormField>
          <div className="tool-actions">
            <Button onClick={handleProcess}>
              {mode === 'format' ? 'Format' : 'Minify'}
            </Button>
            <Button variant="ghost" onClick={handleValidateOnly}>
              Validate Only
            </Button>
          </div>
          <FeedbackMessage type={feedback.type}>{feedback.message}</FeedbackMessage>
        </Card>

        <Card>
          <CardHeader
            title="Result"
            description="Formatted or minified output ready to copy."
            action={<CopyButton value={output} />}
          />
          <div className="output-panel">
            <span className="output-panel__label">
              {mode === 'format' ? 'Formatted JSON' : 'Minified JSON'}
            </span>
            <pre>{output || 'The result will appear here.'}</pre>
          </div>
        </Card>
      </div>
    </ToolLayout>
  );
};

export default JsonFormatter;
